import { badgesList } from './badges/index.js';

export default {
  badgesList
};



// WEBPACK FOOTER //
// ./src/shared/index.js